export const UPLOAD_CODE = {
  getOSSTokenDataError: 100,
  getOSSClientError: 101,
  getFileHashError: 102,
  uploadImageError: 103,
  uploadModelError: 104,
  multipartUploadError: 105,
  getOSSTokenStatusError: 106,
};

export const BIZ_CODES = ['0', '1', '2'];
